// extracted by mini-css-extract-plugin
module.exports = {"accountBox":"CreateAccountLayout_accountBox__153wc"};